<template>
  <section>
    <div class="swiper-container relproduct">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide unit"
          v-for="product in products"
          :key="product.productsId"
        >
          <div
            class="relproduct--img pointer"
            :style="{
              backgroundImage: `url( ${product.productsMainImageUrl} )`,
            }"
            @click="$router.push({ name: 'ProductDetail', params: { productId : product.productsId } });"
          ></div>
          <div class="relproduct--txt mb-1">{{ product.productsPageEnglishName }}</div>
          <div class="relproduct--name">{{ product.productsPageKoreanName }}</div>
        </div>
      </div>
      <div class="btn_controllLR">
        <div class="swiper-button-next" />
        <div class="swiper-button-prev" />
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from '@/assets/plugins/swiper.min';

export default {
  name: 'RelatedProduct',
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.relproduct = new Swiper('.relproduct', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      speed: 1000,
      slidesPerView: 4.2,
      centeredSlides: true,
      initialSlide: 2,
      height: 600,
      loop: true,
      navigation: {
        nextEl: '.relproduct .swiper-button-next',
        prevEl: '.relproduct .swiper-button-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
      },
    });
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
